const FooterCopyright = () => (
  <div className="footer-copyright">
    <p className="footer-copy-p">&copy; 2026 Traffic & Barrier Solutions, LLC/Material WorX - 
      Website MERN Stack Coded & Deployed by <a className="footer-face" href="/portfolio">MX Systems</a> - All Rights Reserved.</p>
  </div>
);

export default FooterCopyright;
